export default __webpack_public_path__ + "src/appV2/redesign/GuaranteedPay/assets/images/goldCoin.png";